export default function Notfound(){
    return(
        <>
            <h1>404</h1>
            <h1>Page Not Found</h1>
        </>
    )
}